import React, { useState } from "react";
import { Card, ListGroup, Button, Table} from "react-bootstrap";
import { Container, Row, Col, Image } from "react-bootstrap";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import "./img.css";
import LatestUpdates from "./latestupdates";
import { FaFacebook, FaTiktok, FaYoutube, FaInstagram, FaArrowLeft, FaArrowRight } from "react-icons/fa";
import Footer from './footer';

const VisitorVisas = () => {
    return (

        <>
            <Container className="mt-5">
                <Row>
                    {/* Left Section - Image and Title */}


                    <Col md={8} className="d-flex flex-column align-items-center text-center">
                        <Image src="./img/visitor.jpg" alt="Professional Year" fluid />
                        <h2 className="mt-3">Visitor Visa</h2>
                    </Col>

                    {/* Right Section - Latest Posts and Social Media */}
                    <Col md={4}>
                        <Card>
                            <Card.Header className="fw-bold">Latest Posts</Card.Header>
                            <ListGroup variant="flush">
                                <ListGroup.Item><Link to="/professional" className="dropdown-item"> <a href="" className="text-decoration-none">Professional Year</a> </Link></ListGroup.Item>
                                <ListGroup.Item><Link to="/coursechange" className="dropdown-item"> <a href="" className="text-decoration-none">Admissions And Course Change </a></Link></ListGroup.Item>
                                <ListGroup.Item><Link to="/skilledID" className="dropdown-item"> <a href="" className="text-decoration-none">   Skilled Independent Visa (Subclass 189)</a></Link></ListGroup.Item>
                                <ListGroup.Item><Link to="/workregionalvisa" className="dropdown-item"> <a href="" className="text-decoration-none">Skilled Work Regional Visa (Subclass 491)</a></Link></ListGroup.Item>
                                <ListGroup.Item><Link to="/nominatedvisa" className="dropdown-item"> <a href="" className="text-decoration-none">Skilled Nominated Visa (Subclass 190)</a></Link></ListGroup.Item>
                                <ListGroup.Item><a href="https://immi.homeaffairs.gov.au/visas/getting-a-visa/visa-listing/skilled-regional-191"className="dropdown-item text-decoration-none"style={{ color: "#22327f" }} target="_blank"rel="noopener noreferrer" >Permanent Residence visa (Subclass 191)</a></ListGroup.Item>
                                {/* <ListGroup.Item><Link to="/regionalvisa" className="dropdown-item"><a href="" className="text-decoration-none">Skilled Regional Visa (Subclass 887)</a></Link></ListGroup.Item> */
                                <ListGroup.Item><Link to="/tempactivity" className="dropdown-item"><a href="" className="text-decoration-none">Temporary Activity Visa (Subclass 408)</a></Link></ListGroup.Item>
}
                            </ListGroup>
                        </Card>
                    </Col>
                </Row>
            </Container>
            <SecondSection />
           
            <LatestUpdates/>
            <Footer />
        </>
    );

};

export default VisitorVisas;

const SecondSection = () => {
    return (
        <>
            <Container className="mt-4">

                {/* YouTube Embed Section */}
                <Row className="mt-3">
                    <Col md={8}>
                        <p>Visitor visa allows you to visit Australia as a tourist, for business purposes or to visit family for a temporary stay.</p>
                        <p>We have a high success rate in approvals of Visitor visas, and our expert team helps to prepare the documents
                            very accurately and lodges it on your behalf. So if you want to visit Australia or you want your relatives/friends/parents/spouse to visit Australia, contact Bajwa Immigration Consultants today.</p>
                        <h4>BASIC ELIGIBILITY</h4>
                        <p>You must:</p>

                        <ul>
                            <li>Ybe a genuine visitor
                            </li>
                            <li>have enough funds to support your stay and leave</li>
                        </ul>
                        <h4>WHAT YOU CAN DO</h4>
                        <p>This visa stream lets you visit Australia as a tourist, to see family and friends or for purposes other than business or medical treatment.</p>
                        <p>Depending on the application stream, with this visa you can stay in Australia for up to 12 months.</p>
                        <h4>Visa Streams</h4>
                        <motion.button
    initial={{ x: "-100vw", opacity: 0 }}
    animate={{ x: 0, opacity: 1 }}
    transition={{ type: "tween", duration: 0.6, ease: "easeOut" }}
    className="btn btn-danger btn-sm position-fixed bottom-0 stAAT-0 m-3"
    style={{ zIndex: 1050 }}
>
    <i className="bi bi-chat-left-text me-1"></i>
    <a 
        href="https://au.bajwaimmigration.com/book-appointment" 
        className="text-white text-decoration-none"
    >
        Consult Now
    </a>
</motion.button>
<VisaTable/>

                    </Col>

                   {/* Right Side: Sidebar Section (Responsive) */}
<Col xs={12} md={3} className="sidebar-container">
    <Card className="p-3 text-center">
        {/* Bajwa Immigration Image */}
        <Image
            src="./img/brand-logo.png"
            alt="Bajwa Immigration Logo"
            fluid
            className="mb-3"
        />

        <h6 className="fw-bold">Subscribe to our YouTube channel</h6>
        <Button variant="danger" className="mb-3">
            <a href="https://www.youtube.com/channel/UCB2YzDKqwiv4IH4A6zoKKWw">SUBSCRIBE</a>
        </Button>

        <h6 className="fw-bold">Book Consultation</h6>
        <Button variant="warning">BOOK CONSULTATION</Button>

        <h6 className="fw-bold mt-3">Like Us on Facebook !!</h6>
        {/* Facebook Embed */}
        <iframe
            src="https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2FBajwaImmigration&tabs&width=340&height=130&small_header=false&adapt_container_width=true&hide_cover=false&show_facepile=true&appId"
            width="100%"
            height="130"
            style={{ border: "none", overflow: "hidden" }}
            scrolling="no"
            frameBorder="0"
            allowFullScreen
        ></iframe>

        {/* Social Media */}
        <h6 className="fw-bold mt-3">We are also on:</h6>
        <div className="d-flex justify-content-center gap-3">
            <FaInstagram size={30} color="#C13584" />
            <FaTiktok size={30} color="#000" />
            <FaYoutube size={30} color="crimson" />
        </div>
    </Card>
</Col>

                </Row>
            </Container>

        </>
    );
};


const VisaTable = () => {
    return (
        <div className=" mt-4 table-responsive">
            <Table bordered hover className="table">
                <thead className="table">
                    <tr>
                        <th>TYPE</th>
                        <th>DESCRIPTION</th>
                        <th>STAY</th>
                        <th>COST</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>
                            <strong>Tourist Stream (apply in Australia)</strong>
                        </td>
                        <td>
                        This visa stream lets you visit Australia as a tourist, to see family and friends or for purposes other than business or medical treatment	
                        </td>
                        <td>Up to 12 months</td>
                        <td>From AUD365</td>
                    </tr>

                    <tr>
                        <td>
                            <strong>Tourist Stream (apply outside Australia)</strong>
                        </td>
                        <td>
                        This visa stream lets you visit Australia as a tourist, to go on a cruise or to see family and friends.
                        </td>
                        <td>Up to 12 months</td>
                        <td>From AUD145</td>
                    </tr>
                    <tr>
                        <td>
                            <strong>Sponsored Family Stream</strong>
                        </td>
                        <td>
                        This visa stream lets people who are sponsored, usually by a family member, come to Australia to visit their family members.
                        </td>
                        <td>Up to 12 years</td>
                        <td>From AUD145

                        </td>
                    </tr>
                    <tr>
                        <td>
                            <strong>Business Visitor Stream</strong>
                        </td>
                        <td>
                        This visa stream lets you visit Australia for business reasons.
                        </td>

                        <td>Up to 3 years</td>
                        <td>From AUD145

                        </td>
                    </tr>
                    <tr>
                        <td>
                            <strong>Approved Destination Status Stream</strong>
                        </td>
                        <td>
                        This visa stream is for citizens from certain areas of China visiting Australia on a tour organized by an approved travel agent.
                        </td>

                        <td>For the period or until the date we specify in your grant letter</td>
                        <td>From AUD145

                        </td>
                    </tr>
                    <tr>
                        <td>
                            <strong>Frequent Traveller Stream</strong>
                        </td>
                        <td>
                        This visa stream is for citizens of the People’s Republic of China who travel often to Australia for business or personal reasons.
                        </td>

                        <td>The visa can be granted for up to 10 years. Stay up to 3 months each time you enter.</td>
                        <td>From AUD1,065

                        </td>
                    </tr>
                                   </tbody>
            </Table>
        </div>
    );
};